/* eslint-disable react/no-unknown-property */
/* eslint-disable no-shadow */
import React, { useEffect, useRef, useState, useContext, useMemo } from 'react'
import logo from 'image/extension_collect_logo.png'
import success from 'image/extension_collect_success.png'
import classNames from 'classnames'
import { request, util } from 'meinian-package/src/utils'
import * as userAuth from 'meinian-package/src/utils/auth'
import Lottie from 'react-lottie'
import { Icon } from 'meinian-package/src/component'
import { picProcess } from 'meinian-package/src/utils/image'
import AssociateTaskModal from 'meinian-package/src/component//associateTaskModal'
import RightHeader from 'meinian-package/src/component/addInspirationModal/rightHeader'
import AddInspirationFromWrap from 'meinian-package/src/component/addInspirationModal/addInspirationFromWrap'
import { QUERY_TYPE_VALUE, queryTypeList } from 'meinian-package/src/component/addInspirationModal/enum'
import { getTagNameList } from 'meinian-package/src/component/addInspirationModal/utils'
import RightRenderTab from 'meinian-package/src/component/addInspirationModal/rightRenderTab'
import TreeOption from 'meinian-package/src/component/inspirationTreeList'
import FileTreeData from 'meinian-package/src/common/fileTreeData'
import animation from './animation.json'
import { base64ToFile, uploadToOSS, getExtensionFromBase64 } from './utils'
import './collect.less'
import { AccountContext } from '../../context'

const downImg = async (picList = []) => {
  const result = await request.post('/zhikuan/ins/blog/mission/down-img', picList)
  return result
}

export default () => {
  const { userInfo = {} } = useContext(AccountContext)
  const [imgInfos, setImgInfos] = useState([])
  const [currentImgIndex, setCurrentImgIndex] = useState(0)
  const [type, setType] = useState()
  const [ideaMassesLoading, setIdeaMassesLoading] = useState(false)
  const [ideaMasses, setIdeaMasses] = useState([])
  const [collectLoading, setCollectLoading] = useState(false)
  const [collectResult, setCollectResult] = useState()
  const [ideaMass, setIdeaMass] = useState({})
  const $img = useRef()
  const currentImg = imgInfos[currentImgIndex] || {}

  const [taskConfirmVisible, setTaskConfirmVisible] = useState(false)
  const taskConfirmTemp = useRef(null)
  const treeData = useRef()

  const [formParams, setFromParams] = useState({
    tags: new Set(), // tagNameList 标签列表
    price: null, // 参考价格
    description: null, // 描述
    gender: null, // 行业
    propertyValueParamList: [], // 自定义属性实体信息,
    styleTitle: '',
  })
  const [selectIds, setSelectIds] = useState([])
  const [selectItems, setSelectItems] = useState([])
  const [queryType, setQueryType] = useState(3)
  const [singleCollection, setSingleCollection] = useState(true) // 单选采集

  const [keyWords, setKeyWords] = useState()
  const pageParams = useRef({
    start: 0,
    pageSize: 20,
  })
  const resultList = useRef([])
  const totalRef = useRef(0)

  useEffect(() => {
    const onMessage = async (e) => {
      const payload = e.data
      if (payload.cmd === 'res_get_img_infos') {
        payload.data = payload.data || {}
        const downloadImgPromise = []
        payload.data.imgInfos.forEach((item) => {
          if (item.url && !item.url.match(/^data/) && !item.url.includes('https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com')) {
            const _promise = new Promise((resolve) => {
              downImg([item.url])
                .then((image) => {
                  if (image.length) {
                    item.transformUrl = image[0]
                    item.imageStatus = 'success'
                  } else {
                    item.imageStatus = 'error'
                  }
                  resolve()
                })
                .catch(() => {
                  item.imageStatus = 'error'
                  resolve()
                })
            })
            downloadImgPromise.push(_promise)
          } else {
            item.transformUrl = item.url
          }
        })
        await Promise.all(downloadImgPromise)
        setImgInfos(payload.data.imgInfos?.map((m) => ({ ...m, title: m.title?.slice(0, 50), tagNameList: [] })) || [])
        if (payload.data.imgInfos?.[0]) {
          setFromParams((pre) => ({ ...pre, styleTitle: payload.data.imgInfos[0]?.title?.slice(0, 50) }))
        }
        setType(payload.data.type || '2')
      }
    }
    window.addEventListener('message', onMessage, false)
    window.postMessage({ cmd: 'get_img_infos' }, '*')
    return () => {
      window.removeEventListener('message', onMessage, false)
    }
  }, [])
  useEffect(() => {
    fetchIdeaMasses(queryType)
  }, [])

  const fetchIdeaMasses = async (_queryType, _keyWords = keyWords, _pageParams = pageParams.current) => {
    setIdeaMassesLoading(true)

    const obj = {
      queryType: _queryType,
      onlyExistInspiration: 0,
    }
    if (_queryType === QUERY_TYPE_VALUE.collected) {
      obj.queryType = 3
      obj.onlyExistInspiration = 1
    }
    // 兼容跨境platformId
    const res = await request.post('/zhikuan/ins/inspiration/list-collect-inspiration-tree', {
      ...obj,
      ..._pageParams,
      likeName: _keyWords,
    })
    totalRef.current = res.resultCount
    const tempResult =
      _pageParams.start === 0
        ? (resultList.current = res.resultList)
        : (resultList.current = [...resultList.current, ...res.resultList])
    treeData.current = new FileTreeData({
      data: tempResult,
      checkedValues: selectIds,
      childrenKey: 'childs',
    })
    setIdeaMasses(treeData.current.data)
    setIdeaMassesLoading(false)
  }

  const onImgLoad = () => {
    if (!currentImg.width || !currentImg.height) {
      currentImg.width = $img.current.naturalWidth
      currentImg.height = $img.current.naturalHeight
      setImgInfos((pre) => [...pre])
    }
  }

  const summitCollect = async (ideaMass) => {
    setCollectLoading(true)
    try {
      const newData = []
      imgInfos.forEach((item) => {
        if (
          item.transformUrl &&
          item.transformUrl.match(/^data/) &&
          !item.transformUrl.includes('https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com')
        ) {
          const mime = getExtensionFromBase64(item.transformUrl)
          const file = base64ToFile(item.transformUrl)
          newData.push(
            uploadToOSS(file, null, null, null, `.${mime}`).then((_data) => {
              item.transformUrl = _data.url
              item.hashMD5 = _data.hashMD5
            })
          )
        }
      })
      await Promise.all(newData)
      const collectItems =
        type === '2'
          ? [
              {
                originUrl: currentImg.location.href,
                originWeb: currentImg.location.hostname,
                title: formParams.styleTitle || currentImg.title?.slice(0, 50),
                platformId: 27,
                picItemList: imgInfos.map((m) => ({
                  picUrl: m.transformUrl,
                  height: m.height,
                  width: m.width,
                })),
              },
            ]
          : imgInfos.map((m) => ({
              originUrl: m.location.href,
              originWeb: m.location.hostname,
              title: formParams.styleTitle || m.title?.slice(0, 50),
              platformId: 27,
              picItemList: [
                {
                  picUrl: m.transformUrl,
                  height: m.height,
                  width: m.width,
                },
              ],
            }))
      const res = await request.post('/zhikuan/user-img/collect-img', {
        collectItems,
        inspirationIdList: ideaMass.map((item) => item.id),
        tagNameList: getTagNameList(formParams?.tags),
        ...formParams,
      })
      if (ideaMass.length === 1) {
        if (
          res?.effectTargetNum &&
          userAuth.isPermissions(res?.loginUserInfo?.inspirationPermissions, ['F21']) &&
          res.collectIdList?.length <= 1
        ) {
          taskConfirmTemp.current = res
          setTaskConfirmVisible(true)
        }
      }
      util.track('mn-add-style', {
        module1: '采集插件',
      })
      setIdeaMass(ideaMass[0])
      setCollectResult(res)
    } catch (err) {
      setCollectResult(false)
    }
    setCollectLoading(false)
  }
  const onTaskConfirmOk = async () => {
    setTaskConfirmVisible(false)
  }

  const _logout = () => {
    request.get('/backend-api/sso-auth/auth/logout')
    localStorage.clear()
    util.setCookie(process.env.REACT_APP_TOKEN, '', -1)
    window.location.href = '/login'
  }

  const failedImages = useMemo(() => {
    const _images = imgInfos.filter((item) => item.imageStatus === 'error')
    return _images
  }, [imgInfos])

  const onFormChange = (valObj) => {
    setFromParams((pre) => ({ ...pre, ...valObj }))
  }

  const onChangeTab = (val) => {
    setQueryType(val)
    fetchIdeaMasses(val)
  }
  const onTreeChange = (checked, currentItem) => {
    if (checked) {
      treeData.current.checkSelectMarkStatus(currentItem)
      setSelectItems((pre) => {
        pre.push(currentItem)
        return [...pre]
      })
      setSelectIds((pre) => {
        pre.push(currentItem.value)
        return [...pre]
      })
    } else {
      treeData.current.checkNoSelectMarkStatus(currentItem)
      const _findIndex = selectIds.findIndex((i) => i === currentItem.value)
      const _currentFindIndex = selectItems.findIndex((i) => i.value === currentItem.value)
      setSelectItems((pre) => {
        pre.splice(_currentFindIndex, 1)
        return [...pre]
      })
      setSelectIds((pre) => {
        pre.splice(_findIndex, 1)
        return [...pre]
      })
    }
  }
  const onItemCollect = (_, inspiration) => {
    summitCollect([inspiration])
    return false
  }
  const treeOptionRef = useRef(null)

  return (
    <div className="mn-extension-collect">
      {collectLoading && <Loading />}
      {taskConfirmVisible && (
        <AssociateTaskModal
          collectId={taskConfirmTemp.current?.collectIdList?.[0] || taskConfirmTemp.current?.collectId}
          visible={taskConfirmVisible}
          onClose={() => setTaskConfirmVisible(false)}
          onOk={onTaskConfirmOk}
        />
      )}
      <div className="nav">
        账户：{userInfo?.name}
        <a className="logout" onClick={_logout}>
          退出登陆
        </a>
      </div>
      <div className={classNames('collect-wrapper', { loading: collectLoading })}>
        <div className="header">
          <img className="logo" src={logo} />
          {failedImages.length ? (
            <div className="collect-failed">
              <Icon type="m-tishicuowu" />有
              <a className="number">
                {failedImages.length}张图片
                <div className="failed-images">
                  {failedImages.map((image) => (
                    <img src={picProcess(image.url)} />
                  ))}
                </div>
              </a>
              上传失败，需要手动下载图片上传。
            </div>
          ) : null}
          <div className="meinian-space" />
          <Icon type="m-tishixinxi" className="type-icon" />
          <div className="type-text">
            {imgInfos.length === 1 ? '单图采集' : type === '2' ? '将所有图片采集成同一个款式' : '将每张图片采集成独立款式'}
          </div>
        </div>
        {collectResult ? (
          <Success ideaMass={ideaMass} />
        ) : (
          <div style={{ display: 'flex' }}>
            <div className="img-wrapper">
              <AddInspirationFromWrap listWidth={412} formParams={formParams} onFormChange={onFormChange}>
                <div style={{ position: 'relative' }}>
                  <img
                    referrer="no-referrer"
                    className="img"
                    src={picProcess(currentImg.transformUrl)}
                    onLoad={onImgLoad}
                    ref={$img}
                  />
                  {imgInfos.length > 1 && type === '1' ? (
                    <div className="img-index">
                      {currentImgIndex + 1}/{imgInfos.length}
                    </div>
                  ) : null}
                  {currentImgIndex && type === '1' ? (
                    <a className="pre-img" onClick={() => setCurrentImgIndex((pre) => pre - 1)}>
                      <Icon type="m-Vxing_zuo" />
                    </a>
                  ) : null}
                  {currentImgIndex < imgInfos.length - 1 && type === '1' ? (
                    <a className="next-img" onClick={() => setCurrentImgIndex((pre) => pre + 1)}>
                      <Icon type="m-Vxing_you" />
                    </a>
                  ) : null}
                  {imgInfos.length > 1 ? <div className="img-count">{imgInfos.length}张图片</div> : null}
                </div>
                <div className="info">
                  <span>
                    {currentImg.width}x{currentImg.height}
                  </span>
                  <div className="meinian-space" />
                  <span>{currentImg.location?.hostname}</span>
                </div>
              </AddInspirationFromWrap>
            </div>
            <div className="idea-masses-wrapper">
              <RightHeader
                selects={selectIds}
                onClear={async () => {
                  selectIds.length = 0
                  selectItems.length = 0
                  await fetchIdeaMasses(queryType)
                  treeOptionRef.current?.onClear()
                }}
                mode={singleCollection}
                onMode={async () => {
                  selectIds.length = 0
                  selectItems.length = 0
                  setSingleCollection(!singleCollection)
                  await fetchIdeaMasses(queryType)
                  treeOptionRef.current?.onClear()
                }}
              />
              <TreeOption
                type="page"
                onLoad={() => {
                  pageParams.current.start += 20
                  if (pageParams.current.start < totalRef.current) {
                    fetchIdeaMasses(queryType)
                  }
                }}
                keyWords={keyWords}
                onKeyWords={(val) => {
                  pageParams.current.start = 0
                  fetchIdeaMasses(queryType, val)
                  setKeyWords(val)
                }}
                ref={treeOptionRef}
                collectBtnDisabled={!selectItems.length}
                onItemCollect={onItemCollect}
                singleCollection={singleCollection}
                onOk={() => summitCollect(selectItems)}
                treeData={treeData.current}
                data={ideaMasses}
                tabOptionHead={queryTypeList.find((item) => queryType === item.value)}
                renderTab={() => <RightRenderTab value={queryType} onChange={onChangeTab} data={ideaMasses} />}
                scrollHeight={370}
                listWidth={412}
                value={selectIds}
                loading={ideaMassesLoading}
                onCreateInspiration={(id, name, current) => {
                  if (!singleCollection) {
                    selectIds.push(id)
                    selectItems.push(current)
                    fetchIdeaMasses(queryType)
                  } else {
                    summitCollect([{ id, name }])
                  }
                }}
                onChange={onTreeChange}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

const Loading = () => {
  return (
    <div className="collect-loading">
      <Lottie
        options={{
          loop: true,
          autoplay: true,
          animationData: animation,
        }}
        height={188}
        width={600}
      />
      <div className="text">正在采集，请勿关闭此页面哦</div>
    </div>
  )
}

const Success = ({ ideaMass }) => {
  const url = useMemo(() => {
    const curItem = ideaMass
    if (curItem?.parent) {
      return `/meinian/home/coll/detail/${curItem.id}?inspirationId=${curItem.id}&parentId=${curItem.parent.name}`
    }
    return `/meinian/home/coll/detail/${curItem.id}?inspirationId=${curItem.id}`
  }, [ideaMass])

  return (
    <div className="collect-success">
      <img src={success} />
      <div className="text">
        已成功采集 至<a href={url}>「{ideaMass.name}」</a>
      </div>
    </div>
  )
}
